<template>
  <v-layout row justify-center>
    <v-dialog v-model="helpcenterDialog" width="600px">
      <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text Kanit"><v-icon color="white">info</v-icon>&nbsp;&nbsp;ศูนย์ช่วยเหลือ</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
      <v-card>
        <v-card-text style="font-size: 18px;" class="Kanit"><b>บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310</b>
        </v-card-text>
        <div style="padding-left: 1vw;font-size: 16px;" class="Kanit">
          <span><b>โทรศัพท์: 02-257-7269</b></span><br>
          <span><b>อีเมล: one-platform@inet.co.th</b></span>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat" @click="closeDialog" class="Kanit">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script type="text/javascript">
export default {
  props: {'helpcenterDialog': false},
  data: () => ({

  }),
  methods: {
    closeDialog () {
      this.$emit('closeHelpcenter', false)
    }
  }
}
</script>
<style type="text/css">
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/managebot/dialogNavbar/helpcenterDialog.vue